//url的正则
const validateURL = (url) => {
    const urlRegex = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/;
    return urlRegex.test(url);
}

//邮箱的正则
const validateMail = (mail) => {
    const urlRegex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    return urlRegex.test(mail);
}

// 特殊字符正则
const validateSpace = (str) => {
    let pattern = /\s*\S+?/;
    return pattern.test(str)
}


export {validateURL, validateMail, validateSpace}
